import type { Text } from '@kkf/design'

/**
 * What every controlled value in the garage is called, in both languages.
 *
 * These are **discriminants**, not copy: `group` on a service, `group` on a programme and
 * `kind` on a tour are what the listing pages group and filter on, and what `order`
 * compares against. Translating the value would mean a group nothing falls into.
 *
 * So the value stays canonical and only the label changes — the same split
 * `data/vocabulary.ts` makes in Partners and the resort. `useVocabulary` resolves it,
 * and an unrecognised value prints itself.
 */
export const GARAGE_VOCABULARY: Readonly<Record<string, Text>> = {
  // ── What a service is for ─────────────────────────────────────────────────────────────
  Recovery: { en: 'Recovery', mn: 'Чирэх үйлчилгээ' },
  Workshop: { en: 'Workshop', mn: 'Цех' },
  Together: { en: 'Together', mn: 'Хамтдаа' },

  // ── Which track a programme sits on ───────────────────────────────────────────────────
  Trade: { en: 'Trade', mn: 'Мэргэжил' },
  Technology: { en: 'Technology', mn: 'Технологи' },
  Mentoring: { en: 'Mentoring', mn: 'Зөвлөгөө' },
  Faith: { en: 'Faith', mn: 'Итгэл' },
  'Open to all': { en: 'Open to all', mn: 'Бүгдэд нээлттэй' },

  // ── What kind of day out it is ────────────────────────────────────────────────────────
  Tour: { en: 'Tour', mn: 'Аялал' },
  Training: { en: 'Training', mn: 'Сургалт' },
  Rental: { en: 'Rental', mn: 'Түрээс' },
}
